import { useEffect } from "react";
import { useRouter } from "next/router";

import isMobileDevice from "utils/isMobileDevice";

import { hasIosParam } from "components/products/lib/paramCheck";

import { useGoogleAdTargeting } from "../../../hooks/useGoogleAdTargeting";

export const ProductCategoryGoogleAdTargeting = ({
  category,
  subcategory,
}: {
  category: string;
  subcategory?: string;
}) => {
  const router = useRouter();
  const isIos = hasIosParam(router);

  useEffect(() => {
    window.googletag = window.googletag || { cmd: [] };
    window.googletag.cmd.push(() => {
      window.googletag.pubads().enableLazyLoad({ fetchMarginPercent: -1 });
    });
  }, []);

  useGoogleAdTargeting({
    "brand-expression": "true",
    device: getDeviceType(isMobileDevice(), isIos),
    "product-category": category,
    "product-subcategory": subcategory,
  });

  return null;
};

const getDeviceType = (isMobile: boolean, isIos: boolean) => {
  let device = "web";
  if (isMobile) {
    device = isIos ? "ios-app" : "android-app";
  }
  return device;
};
